import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex-colum h-100" }
const _hoisted_2 = { class: "d-flex justify-content-between bd-highlight mb-3" }
const _hoisted_3 = {
  class: "align-self-center mb-3",
  style: {"height":"30px"}
}
const _hoisted_4 = { class: "table table-bordered table-striped table-sm member-list" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      width: "80px"
    }, "序号"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "标题"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "子类型"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      width: "120px"
    }, "操作")
  ])
], -1)
const _hoisted_6 = { id: "member-list" }
const _hoisted_7 = { class: "flex-row flex-align-center" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddTagDialog = _resolveComponent("AddTagDialog")!
  const _component_LoadingDialog = _resolveComponent("LoadingDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openEditTagDialog()))
          }, "添加")
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("table", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("tbody", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dataList, (value, idx) => {
              return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                _createElementVNode("td", null, _toDisplayString(50 * ($setup.nowPage - 1) + idx + 1), 1),
                _createElementVNode("td", null, _toDisplayString(value.title), 1),
                _createElementVNode("td", null, _toDisplayString(value.subtype), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("img", {
                      class: "button-icon",
                      src: "/assets/ic_edit.png",
                      onClick: ($event: any) => ($setup.openEditTagDialog(value))
                    }, null, 8, _hoisted_8),
                    _createElementVNode("img", {
                      class: "button-icon img-margin",
                      src: "/assets/ic_trash.png",
                      onClick: ($event: any) => ($setup.deleteTag(value))
                    }, null, 8, _hoisted_9)
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createVNode(_component_AddTagDialog, {
      show: _ctx.showAddDialog,
      tag: _ctx.editing,
      onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAddDialog = false)),
      hasImage: true,
      onConfirm: $setup.editTag
    }, null, 8, ["show", "tag", "onConfirm"]),
    _createVNode(_component_LoadingDialog, { show: _ctx.showLoadingDialog }, null, 8, ["show"])
  ], 64))
}